import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import {
    ArrowRight,
    RowLinkDetails,
    RowLinkLabel,
    TableSportsRowLinkWrapper,
} from 'src/ui/components/table/sports/row/link/TableSportsRowLink.style';
import { observer } from 'src/utils/mobx-react';

interface TableSportsRowLinkPropsType {
    className?: string;
    dataTest?: string;
    formattedDate: string;
    formattedTime: string;
    handleClick: () => void;
    label: string;
}

export const TableSportsRowLink = observer(
    'TableSportsRowLink',
    ({
        className,
        dataTest,
        formattedDate,
        formattedTime,
        handleClick,
        label,
    }: TableSportsRowLinkPropsType): JSX.Element => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        return (
            <TableSportsRowLinkWrapper
                className={className}
                onClick={handleClick}
                data-test={dataTest ?? 'table-sports-row-link-wrapper'}
            >
                <RowLinkLabel data-test='table-sports-row-link-label'>{label}</RowLinkLabel>
                {formattedDate !== '' && (
                    <RowLinkDetails variant={configState.componentVariants.sportsbookVariant}>
                        {formattedDate}
                    </RowLinkDetails>
                )}
                {formattedTime !== '' && (
                    <RowLinkDetails variant={configState.componentVariants.sportsbookVariant}>
                        {formattedTime}
                    </RowLinkDetails>
                )}
                <ArrowRight
                    position='right'
                    variant={configState.componentVariants.sportsbookVariant}
                />
            </TableSportsRowLinkWrapper>
        );
    }
);
